import { Table } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

function Roles() {
    let [roles, setRoles] = useState()
    useEffect(() => {
        axios.get('roles').then(data => {
            setRoles(data.data)
        })
    }, [])
    return (
        <div>
            <Table 
                columns={[
                    {
                        title: 'Name',
                        dataIndex: 'name',
                        key: 'name',
                    }
                ]}
                dataSource={roles}
                bordered
                pagination={false}
            /> 
        </div>
    );
}

export default Roles;